/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/core';

@Component({
  standalone: false,
  selector: 'adn-default-item-title-route',
  template: `
    <adn-default-item-title
      *ngIf="context"
      [model]="context.model"
      [modelComms]="context.modelComms"
      [objectTypeKey]="context.objectTypeKey"
      [crumbParams]="context.titleCrumbParams"
      [titleVariant]="context.titleVariant"
      [lineItemInfo]="context.lineItemInfo"
      [folioFromParam]="context.folioFromParam"
      [advertiserFromParam]="context.advertiserFromParam"
      [workspace]="context.workspace"
      [isNew]="context.isNew">
    </adn-default-item-title>
  `
})
export class DefaultItemTitleRouteComponent implements OnInit {
  context: Record<string, any>;

  constructor(private readonly uiRouter: UIRouter) {
  }

  ngOnInit(): void {
    const injector = this.uiRouter.globals.successfulTransitions.peekTail()?.injector();
    const get = (key: string) => {
      try {
        return injector?.get(key);
      } catch (e) {
        return null;
      }
    };
    this.context = {
      model: get('model'),
      modelComms: get('modelComms'),
      objectTypeKey: get('objectTypeKey'),
      titleCrumbParams: get('titleCrumbParams'),
      titleVariant: get('titleVariant'),
      lineItemInfo: get('lineItemInfo'),
      folioFromParam: get('folioFromParam'),
      advertiserFromParam: get('advertiserFromParam'),
      workspace: get('workspace'),
      isNew: get('isNew') ?? !!this.uiRouter.globals.params.isNew
    };
  }
}
